import { logDispatcher } from "src/app/core/decorators/state.decorators";

export namespace AttendanceContractTypeActions {

    @logDispatcher
    export class GetAttendanceContractType {
      static readonly type = '[AttendanceContractType] GetAttendanceContractType';
      constructor() {}
    }
  
  }